<template>
  <div class="right_box">
    <div class="tips">
     彭祖世家网
    </div>
    <div style="height: 50px;line-height: 50px;color:#666666;font-size: 14px">
      共 <span>{{ table.count }}</span> 条数据
    </div>
    <div class="topBox">
      <el-select v-model="value1" placeholder="请选择" class="selects" @change="handleSearch">
        <el-option
          v-for="item in selectData1"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-select v-model="value2" placeholder="请选择" class="selects selects2" @change="sortTypeData">
        <el-option
          v-for="item in selectData2"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <div class="cancelCollectBtn">
      <el-button :disabled="ISShow" type="success" size="medium" class="quxiao" @click="goDel('all')">
        删除评论
      </el-button>
    </div>
    <div class="PcshowBox">
      <!--<div class="cancelCollectBtn">-->
      <!--<el-button :disabled="ISShow" type="success" size="medium" class="quxiao" @click="cancelRemove('all')">-->
      <!--取消收藏-->
      <!--</el-button>-->
      <!--</div>-->
      <el-table
        :data="table.data"
        class="tableBox"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        style="width:100%"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          min-width="10%"
        />
        <el-table-column
          min-width="60%"
          label="内容"
        >
          <template slot-scope="scope">
            <div>
              <p class="content_speak">
                {{ scope.row.SPEAK_CONTENT }}
              </p>
              <p class="speak_name">
                <span class="detailBtn" @click="goDetail(scope.row)">来自：{{ scope.row.CONTENT_TITLE }}</span><span style="float: right">{{ scope.row.CREATE_DATE }}</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="15%"
          prop="CREATE_DATE"
          label="状态"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.SPEAK_IS_AUDIT==0">待审核</span>
            <span v-if="scope.row.SPEAK_IS_AUDIT==1">未通过</span>
            <span v-if="scope.row.SPEAK_IS_AUDIT==2">已通过</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="20%"
          label="操作"
        >
          <template slot-scope="scope">
            <span class="cancelBtn" style="color: #5aa0fd" @click="goDetail(scope.row)">阅读</span>
            <span class="cancelBtn" @click="goDel(scope.row.SPEAK_ID)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="phoneBox">
      <div v-for="(item,index) in table.data" :key="index">
        <div class="phoneList">
          <div class="phoneNames" @click="goDetail(item.CONTENT_ID)">
            <span class="templateName">{{ item.TEMPLATE_NAME }}</span>
            <span class="columnName">【{{ item.COLUMN_NAME }}】</span>
            <span class="contentTitle ellipsis-1">{{ item.CONTENT_TITLE }}</span>
          </div>
          <div>
            <span class="cancelBtn" @click="cancelRemove(item)">取消</span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <pagination
        :total="table.count"
        :pager="table.param.index"
        :pagesize="table.param.size"
        style="text-align:center;margin:40px 0 60px;"
        layout="sizes, pager, next, jumper"
        @pagersizechange="pagerSizeChange"
        @pagerchange="pagerChange"
      />
    </div>
  </div>
</template>

<script>
import pagination from '@/components/userCenter/pagination.vue'
import { myCommont, delMyCommont } from '@/api/api.js'
import Vue from 'vue'
export default {
  name: 'Index',
  components: {
    pagination
  },
  inject: ['reload'],
  data() {
    return {
      zgw1: require('@/static/zgw1.png'),
      zgw2: require('@/static/zgw2.png'),
      py1: require('@/static/py1.png'),
      py2: require('@/static/py2.png'),
      currentSet: 1,
      value1: '全部状态', // ////选择的分类
      value2: '时间倒序', // //正序倒序
      ISShow: true,
      currentTypeIndex: 0,
      selectData1: [
        {
          label: '全部状态',
          value: '3'
        },
        {
          label: '待审核',
          value: '0'
        }, {
          label: '已通过',
          value: '2'
        }, {
          label: '未通过',
          value: '1'
        }
      ],
      selectData2: [
        {
          label: '时间倒序',
          value: 'DESC'
        },
        {
          label: '时间正序',
          value: 'ASC'
        }
      ],
      table: {
        data: [],
        param: {
          collectionType: '1',
          userId: '',
          sortType: 'DESC',
          sortFieldName: 'CREATE_DATE',
          index: 1,
          size: 10
        },
        count: 0,
        selectArry: ''
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      // console.log(this.table.param)
      this.table.param.userId = this.getLoca('userid')
      myCommont(this.table.param).then(response => {
        // console.log(response.data)
        this.table.data = response.data.listMapData
        for (let i = 0; i < this.table.data.length; i++) {
          var item = this.table.data[i]
          item.ischeck = false
        }
        Vue.set(this.table.data)
        this.table.count = response.data.count
      })
    },
    handleSearch() {
      console.log(this.value1)
      if (this.value1 == 3 || this.value1 == '全部状态') {
        this.table.param.speakIsAudit = ''
      } else {
        this.table.param.speakIsAudit = this.value1
      }
      this.fetchData()
    },
    // 日期排序
    sortTypeData() {
      // console.log(this.value2)
      this.table.param.sortType = this.value2
      this.fetchData()
    },
    pagerSizeChange: function(size) {
      this.table.param.size = size
      this.table.param.index = 1
      this.fetchData()
    },
    pagerChange: function(pager) {
      this.table.param.index = pager
      this.fetchData()
    },
    // 选中状态
    handleSelectionChange: function(res) {
      this.table.selectArry = res
      if (res.length >= 1) {
        this.ISShow = false
      } else {
        this.ISShow = true
      }
    },
    // //取消收藏单个和批量删除
    goDel(thisOne) {
      var newMerry = []
      if (thisOne !== 'all') {
        // console.log(thisOne)
        newMerry.push(thisOne)
        // userId.push(thisOne.USER_ID)
      } else {
        // console.log(this.table.data)
        this.table.selectArry.forEach(a => {
          newMerry.push(a.SPEAK_ID)
        })
        // console.log(newMerry)
      }
      this.$confirm('确定要删除评论吗?', '取消提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delMyCommont({
          'speakId': newMerry.toString(),
          'userId': this.getLoca('userid')
        }).then(res => {
          if (res.data) {
            this.$message({
              message: '恭喜你，删除评论成功！',
              type: 'success'
            })
            this.reload()
          } else {
            this.$message.error(res.message + '删除失败')
          }
        })
        // 点击删除键直接删除单个
      })
    },
    // 切换模板
    hanerTemolate(item, index) {
      this.currentTypeIndex = index
      this.table.param.templateId = item.value
      this.fetchData()
    },
    goDetail: function(item) {
      var href = ''
      if (item.RES_TYPE) {
        href = 'sourceView?sourceId=' + item.CONTENT_ID + '&type=' + item.RES_TYPE
      } else {
        href = '/Detail?contentId=' + item.CONTENT_ID
      }
      window.open(href, '_blank')
    },
    changeSet(index) {
      this.currentSet = index
      this.table.param = {
        collectionType: index,
        userId: '',
        templateId: '',
        sortFieldName: '',
        sortType: '',
        index: 1,
        size: 10
      }
      this.currentTypeIndex = 0
      this.fetchData()
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .content_speak{
        font-size: 14px;
        color: #333333;;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .speak_name{
        font-size: 14px;
        color: #999999;
        .detailBtn{
            cursor: pointer;
            &:hover{
                color: #ed4040;
            }
        }
    }
    .cancelCollectBtn{
        margin:20px 0;
    }
    .cellSty{
        .cell{
            padding-left: 20px!important;
        }
    }
    .phoneBox{
        display: none;
    }
    .right_box{
            width: 840px;
            display: inline-block;
            vertical-align: top;
            background-color: #fff;
            padding: 0 30px;
            overflow: hidden;
            .tips{
                display: inline-block;
                padding-left: 7px;
                border-left: 3px solid #E0466E;
                height: 17px;
                line-height: 17px;
                margin-top: 30px;
                font-size: 18px;
            }
        }

    .toptitle {
        line-height: 40px;
        height: 40px;
        border-bottom: 1px solid #e5e5e5;
        span {
            display: inline-block;
            height: 39px;
            font-size: 14px;
            color: #4e4e4e;
            width: 72px;
            border-bottom: 2px solid #ed4040;
        }
    }
    .searchs{
        width: 217px;
        display: inline-block;
        margin-left: 12px;
        vertical-align: middle;
    }
    .collect_search{
        display: inline-block;
        position: absolute;
        width: 30px;
        height: 40px;
        font-size: 18px;
        line-height: 40px;
        color: #b3b3b3;
        right: 0;
        cursor: pointer;
    }
    .searchBox{
        position: relative;
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
    }
    .topBox{
        padding: 18px 30px;
        padding-left: 10px;
        background-color: #F1F7FF;
        margin-bottom: 15px;
        .btnType1{
            padding: 5px 20px;
            border: 1px solid #E0466E;
            border-radius: 3px;
            color: #ffffff;
            font-size: 14px;
            background-color: #E0466E;
            margin-left: 15px;
            cursor: pointer;
        }
        .btnType1_no{
            padding: 5px 20px;
            border: 1px solid #E5E5E5;
            border-radius: 3px;
            color: #333333;
            font-size: 14px;
            background-color: #fff;
            margin-left: 15px;
            cursor: pointer;
        }
    }
    .selects{
        position:relative;
        width: 160px;
        margin-left: 20px;
    }
    .selects2{
        margin-left: 40px;
    }
    .quxiao{
        background-color: #ed4040!important;
        border: none!important;
    }
    .Btn{
        color: #5aa0fd;
        font-size: 14px;
        cursor: pointer;
    }
    ///收藏的单个删除功能添加
    .cancelBtn{
        color: #e0466e;
        font-size: 14px;
        margin-left: 10px;
        cursor: pointer;
    }
    .templateName{
        width: 38px;
        height: 22px;
        display: inline-block;
        color: #ffffff;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        border-radius: 3px;
        margin-right: 10px;
    }

</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {
        .myCollContent{
            padding: 0 10px;
        }
        .selects{
            width: 30vw;
        }
        .searchBox{
            width: 50vw;
        }
        .searchs{
            width: 45vw;
        }
        .PcshowBox{
            display: none;
        }
        .phoneBox{
            display: block;
            padding-top: 20px;
            .phoneList{
                position: relative;
                margin: 20px 0;
                .phoneNames{
                    width: calc( 100vw -  100px);
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow:ellipsis
                }
                .cancelBtn{
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }

        }

    }
</style>
<style rel="stylesheet/scss" lang="scss">
    .myCollContent{
        .el-table .cell{
            padding-left: 30px!important;
        }
    }
</style>
